import { BsCalendarEventFill, BsSendCheck } from "react-icons/bs";
import { GoMail, GoChecklist, GoCommentDiscussion, GoQuestion } from "react-icons/go";
import { TbBellCheck } from "react-icons/tb";
import { FaHashtag } from "react-icons/fa6";
import { FiLayers, FiClock, FiZap } from "react-icons/fi";
import { LuFlag } from "react-icons/lu";
import { MdOutlineAssignmentTurnedIn, MdOutlinePeopleAlt, MdPerson } from "react-icons/md";

export const RESOURCE_ICON = {
  message: GoCommentDiscussion,
  email: GoMail,
  task_notifer: BsSendCheck,
  task_reminder: TbBellCheck,
  task: GoChecklist,
  checkpoint: LuFlag,
  all: FiLayers,
  unknown: GoQuestion,
};

export const MESSAGE_ICONS = {
  NEW_HIRE_NETWORK: MdOutlinePeopleAlt,
  USER: MdPerson,
  CHANNEL: FaHashtag,
};

export const BUSINESS_ICONS = {
  START_DATE: BsCalendarEventFill,
  ASSIGNMENT_TYPE: MdOutlineAssignmentTurnedIn,
  TOTAL_ACTIONS: FiZap,
  TRIGGER_AT: FiClock,
};

export const EMOJI_ICONS = {
  target: "➡️",
  triggerAt: "⚡",
  scheduledAt: "🕒",
  startDate: "📅",
  message: "💬",
  email: "✉️",
  task: "📝",
  task_notifier: "📣",
  task_reminder: "🔔",
  sentAt: "✔️",
  failed: "❌",
};
